// 智慧合约
import Log from '../view/log'
import InvestmentLeasingNav from '../view/InvestmentLeasing/InvestmentLeasingNav'
import InvestmentOverview from '../view/InvestmentLeasing/InvestmentOverview/InvestmentOverview'
import RentManagement from '../view/InvestmentLeasing/RentManagement/RentManagement'
import RentModify from '../view/InvestmentLeasing/RentManagement/RentModify'
import PropertyManagement from '../view/InvestmentLeasing/PropertyManagement/PropertyManagement'
import PropertyModify from '../view/InvestmentLeasing/PropertyManagement/PropertyModify'
import DepositManagement from '../view/InvestmentLeasing/DepositManagement/DepositManagement'
import DepositModify from '../view/InvestmentLeasing/DepositManagement/DepositModify'
import ContractManagement from '../view/InvestmentLeasing/ContractManagement/ContractManagement'
import FilingContract from '../view/InvestmentLeasing/ContractManagement/FilingContract'
import FilingContractCurrent from '../view/InvestmentLeasing/ContractManagement/FilingContractCurrent'
import FilingRentWithdrawalDetail from '../view/InvestmentLeasing/ContractManagement/FilingRentWithdrawalDetail'
import ContractAdd from '../view/InvestmentLeasing/ContractManagement/ContractAdd'
import ContractCurrent from '../view/InvestmentLeasing/ContractManagement/ContractCurrent'
import ContractModify from '../view/InvestmentLeasing/ContractManagement/ContractModify'
import ContractCopy from '../view/InvestmentLeasing/ContractManagement/ContractCopy'
import ContractRenewal from '../view/InvestmentLeasing/ContractManagement/ContractRenewal'
import ContractRentChange from '../view/InvestmentLeasing/ContractManagement/ContractRentChange'
import RentWithdrawal from '../view/InvestmentLeasing/ContractManagement/RentWithdrawal'
import RentWithdrawalDetail from '../view/InvestmentLeasing/ContractManagement/RentWithdrawalDetail'
import OtherContractManagement from '../view/InvestmentLeasing/OtherContracts/OtherContractManagement'
import OtherContractAdd from '../view/InvestmentLeasing/OtherContracts/OtherContractAdd'
import OtherContractCurrent from '../view/InvestmentLeasing/OtherContracts/OtherContractCurrent'
import OtherContractModify from '../view/InvestmentLeasing/OtherContracts/OtherContractModify'
import OtherContractRenewal from '../view/InvestmentLeasing/OtherContracts/OtherContractRenewal'
import OtherRentWithdrawal from '../view/InvestmentLeasing/OtherContracts/OtherRentWithdrawal'
import OtherRentWithdrawalDetail from '../view/InvestmentLeasing/OtherContracts/OtherRentWithdrawalDetail'
import OtherFilingContract from '../view/InvestmentLeasing/OtherContracts/OtherFilingContract'
import OtherFilingContractCurrent from '../view/InvestmentLeasing/OtherContracts/OtherFilingContractCurrent'
import OtherFilingRentWithdrawalDetail from '../view/InvestmentLeasing/OtherContracts/OtherFilingRentWithdrawalDetail'
import OtherRentManagement from '../view/InvestmentLeasing/OtherContracts/OtherRentManagement'
import BusinessAddressRegistration from '../view/InvestmentLeasing/OtherContracts/BusinessAddressRegistration'
import OtherBillTypeManage from '../view/InvestmentLeasing/OtherContracts/OtherBillTypeManage'
import RentRoomBillManage from '../view/InvestmentLeasing/RentManagement/RentRoomManagement'
import PropertyRoomBillManage from '../view/InvestmentLeasing/PropertyManagement/PropertyRoomManagement'
import DepositRoomManagement from '../view/InvestmentLeasing/DepositManagement/DepositRoomManagement'

export default [
  /* 智慧合约 */
  {
    path: '/investment_over_view',
    name: 'investment-over-view',
    components: {
      default: InvestmentLeasingNav,
      a: InvestmentOverview
    }
  },
  {
    path: '/rent_management',
    name: 'rent-management',
    components: {
      default: InvestmentLeasingNav,
      a: RentManagement
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/rent_modify/:id',
    name: 'rent-modify',
    components: {
      default: InvestmentLeasingNav,
      a: RentModify
    }
  },
  {
    path: '/property_management',
    name: 'property-management',
    components: {
      default: InvestmentLeasingNav,
      a: PropertyManagement
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/property_modify/:id',
    name: 'property-modify',
    components: {
      default: InvestmentLeasingNav,
      a: PropertyModify
    }
  },
  {
    path: '/deposit_management',
    name: 'deposit-management',
    components: {
      default: InvestmentLeasingNav,
      a: DepositManagement
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/deposit_modify/:id',
    name: 'deposit-modify',
    components: {
      default: InvestmentLeasingNav,
      a: DepositModify
    }
  },
  {
    path: '/contract_management',
    name: 'contract-management',
    components: {
      default: InvestmentLeasingNav,
      a: ContractManagement
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/filing_contract',
    name: 'filing-contract',
    components: {
      default: InvestmentLeasingNav,
      a: FilingContract
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/filing_contract_current/:id',
    name: 'filing-contract-current',
    components: {
      default: InvestmentLeasingNav,
      a: FilingContractCurrent
    }
  },
  {
    path: '/filing_rent_withdrawal_detail/:id',
    name: 'filing-rent-withdrawal-detail',
    components: {
      default: InvestmentLeasingNav,
      a: FilingRentWithdrawalDetail
    }
  },
  {
    path: '/contract_add',
    name: 'contract-add',
    components: {
      default: InvestmentLeasingNav,
      a: ContractAdd
    }
  },
  {
    path: '/contract_current/:id',
    name: 'contract-current',
    components: {
      default: InvestmentLeasingNav,
      a: ContractCurrent
    }
  },
  {
    path: '/contract_modify/:id',
    name: 'contract-modify',
    components: {
      default: InvestmentLeasingNav,
      a: ContractModify
    }
  },
  {
    path: '/contract_copy/:id',
    name: 'contract-copy',
    components: {
      default: InvestmentLeasingNav,
      a: ContractCopy
    }
  },
  {
    path: '/contract_renewal/:id',
    name: 'contract-renewal',
    components: {
      default: InvestmentLeasingNav,
      a: ContractRenewal
    }
  },
  {
    path: '/contract_rent_change/:id',
    name: 'contract-rent-change',
    components: {
      default: InvestmentLeasingNav,
      a: ContractRentChange
    }
  },
  {
    path: '/rent_withdrawal/:id',
    name: 'rent-withdrawal',
    components: {
      default: InvestmentLeasingNav,
      a: RentWithdrawal
    }
  },
  {
    path: '/rent_withdrawal_detail/:id',
    name: 'rent-withdrawal-detail',
    components: {
      default: InvestmentLeasingNav,
      a: RentWithdrawalDetail
    }
  },
  /* 智慧合约 */

  /* 其他合约 */
  {
    path: '/other_contract_management',
    name: 'other-contract-management',
    components: {
      default: InvestmentLeasingNav,
      a: OtherContractManagement
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/other_contract_add',
    name: 'other-contract-add',
    components: {
      default: InvestmentLeasingNav,
      a: OtherContractAdd
    }
  },
  {
    path: '/other_contract_current/:id',
    name: 'other-contract-current',
    components: {
      default: InvestmentLeasingNav,
      a: OtherContractCurrent
    }
  },
  {
    path: '/other_contract_modify/:id',
    name: 'other-contract-modify',
    components: {
      default: InvestmentLeasingNav,
      a: OtherContractModify
    }
  },
  {
    path: '/other_contract_renewal/:id',
    name: 'other-contract-renewal',
    components: {
      default: InvestmentLeasingNav,
      a: OtherContractRenewal
    }
  },
  {
    path: '/other_rent_withdrawal/:id',
    name: 'other-rent-withdrawal',
    components: {
      default: InvestmentLeasingNav,
      a: OtherRentWithdrawal
    }
  },
  {
    path: '/other_contract_renewal_detail/:id',
    name: 'other-rent-withdrawal-detail',
    components: {
      default: InvestmentLeasingNav,
      a: OtherRentWithdrawalDetail
    }
  },
  {
    path: '/other_filing_rent_withdrawal_detail/:id',
    name: 'other-filing-rent-withdrawal-detail',
    components: {
      default: InvestmentLeasingNav,
      a: OtherFilingRentWithdrawalDetail
    }
  },
  {
    path: '/other_filing_contract',
    name: 'other-filing-contract',
    components: {
      default: InvestmentLeasingNav,
      a: OtherFilingContract
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/other_filing_contract_current/:id',
    name: 'other-filing-contract-current',
    components: {
      default: InvestmentLeasingNav,
      a: OtherFilingContractCurrent
    }
  },
  {
    path: '/other_rent_management',
    name: 'other-rent-management',
    components: {
      default: InvestmentLeasingNav,
      a: OtherRentManagement
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/business_address_registration',
    name: 'business-address-registration',
    components: {
      default: InvestmentLeasingNav,
      a: BusinessAddressRegistration
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/other_bill_type_manage',
    name: 'other-bill-type-manage',
    components: {
      default: InvestmentLeasingNav,
      a: OtherBillTypeManage
    },
    meta: {
      keepAlive: true
    }
  },
  // 房间租金账单
  {
    path: '/rent_room_management',
    name: 'rent-room-management',
    components: {
      default: InvestmentLeasingNav,
      a: RentRoomBillManage
    }
  },
  // 房间租金账单
  {
    path: '/property_room_management',
    name: 'property-room-management',
    components: {
      default: InvestmentLeasingNav,
      a: PropertyRoomBillManage
    }
  },
  {
    path: '/deposit_room_management',
    name: 'deposit-room-management',
    components: {
      default: InvestmentLeasingNav,
      a: DepositRoomManagement
    },
    meta: {
      keepAlive: true
    }
  },
  /* 其他合约 */

  // 智慧合约操作日志
  {
    path: '/investment_leasing_log',
    name: 'investment-leasing-log',
    components: {
      default: InvestmentLeasingNav,
      a: Log
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/InvestmentLeasing.js